import React from 'react';
import { Button } from 'semantic-ui-react';
import SubmitButton from './SubmitButton';

export default function CancelGoButtons({ 
  cancelText="cancelar", 
  cancelFn, 
  goText, 
  goFn, 
  goEnabled, 
  warning=false, 
  hideGoButton=false,
  loading=false,
  style={} 
}) {
  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column',
      gap: '10px',
      marginTop: '15px',
      marginBottom: '15px',
      ...(style.container || {})
    }}>
      <Button 
        onClick={cancelFn}
        fluid
        size="large"
        style={{
          height: '50px',
          borderRadius: '8px',
          fontSize: '16px',
          boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
          ...(style.button || {})
        }}
      >
        { cancelText }
      </Button>
      
      {!hideGoButton && (
        <SubmitButton 
          onClick={goFn} 
          enabled={goEnabled} 
          warning={warning}
          loading={loading}
          style={{
            height: '50px',
            borderRadius: '8px',
            fontSize: '16px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)',
            ...(style.button || {})
          }}
        >
          { goText }
        </SubmitButton>
      )}
    </div>
  )
}